


















































































































import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import Multiselect from "vue-multiselect";
import get from "lodash-es/get";
import orderBy from "lodash-es/orderBy";
import {
  AutobedrijfViewModel,
  VestigingViewModel,
  DropdownItemStringViewModel,
  DropdownItemModel
} from "../TypeScriptModels";
import { EventBus } from "../lib/EventBus";

interface ConfigurationViewModel {
  Koppelingen: DropdownItemStringViewModel[];
  Dealers: DropdownItemStringViewModel[];
  Autobedrijven: DropdownItemStringViewModel[];
  AllAutobedrijven: AutobedrijfViewModel[];
  AllVestigingen: VestigingViewModel[];
}

interface UploadResult {
  Success: boolean;
  Message: string | null;
}

interface DealerDetailViewModel {
  Dealernummer: string | null;
  AutobedrijfID: number;
  VestigingID: number;
}

export default Vue.extend({
  components: {
    Multiselect
  },

  data() {
    return {
      file: "",
      uploadresult: {
        Success: false,
        Message: ""
      } as UploadResult,
      pageLoaded: false,
      fileUploading: false,
      value: '',
      configuration: {
        Koppelingen: [],
        Dealers: [],
        Autobedrijven: [],
        AllAutobedrijven: [],
        AllVestigingen: []
      } as ConfigurationViewModel,
      dealerNummerValue: "",
      selectedOptions: {
        autobedrijfValue: [] as any[],
        vestigingValue: [] as any[],
      },
      dealer: {
        Dealernummer: "",
        AutobedrijfID: 0,
        VestigingID: 0
      } as DealerDetailViewModel
    };
  },

  computed: {
    showUploadError(): boolean {
      return !!this.uploadresult.Message;
    },

    showUpload(): boolean {
      return !!this.file;
    },

    showKoppelingen(): boolean {
      return this.koppelingenOptions.length > 0;
    },

    koppelingenOptions(): DropdownItemStringViewModel[] {
      return orderBy(
        get(this.configuration, "Koppelingen", []),
        ["Omschrijving"],
        ["asc"]
      );
    },

    showDealers(): boolean {
      return this.dealerOptions.length > 0;
    },

    dealerOptions(): DropdownItemStringViewModel[] {
      return orderBy(
        get(this.configuration, "Dealers", []),
        ["Omschrijving"],
        ["asc"]
      );
    },

    showAutobedrijven(): boolean {
      return this.autobedrijvenOptions.length > 0;
    },

    autobedrijvenOptions(): DropdownItemStringViewModel[] {
      return orderBy(
        get(this.configuration, "Autobedrijven", []),
        ["Omschrijving"],
        ["asc"]
      );
    },

    allAutobedrijvenOptions(): AutobedrijfViewModel[] {
      return orderBy(
        get(this.configuration, "AllAutobedrijven", []),
        ["Omschrijving"],
        ["asc"]
      );
    },

    dealerNummerFilled(): boolean {
      return this.dealerNummerValue !== undefined && this.dealerNummerValue.length > 0;
    },

    autobedrijfSelected(): boolean {
      return get(this.selectedOptions, "autobedrijfValue.Id") !== undefined;
    },

    vestigingSelected(): boolean {
      return get(this.selectedOptions, "vestigingValue.Id") !== undefined;
    },

    allVestigingOptions(): VestigingViewModel[] {
      var selectedAutobedrijf = get(this.selectedOptions, "autobedrijfValue", []);
      var selectedAutobedrijfID = get (selectedAutobedrijf, "Id", []);

      if(selectedAutobedrijfID === undefined) {
        return [];
      } else {
          return orderBy(
          get(this.configuration, "AllVestigingen", []).filter(v => v.AutobedrijfId === selectedAutobedrijfID),
          ["Omschrijving"],
          ["asc"]
        );
      }
    },
  },

  mounted() {
    this.getStatus();
  },

  methods: {
    handleFileUpload() {
      let elem = this.$refs.file as any;
      if (elem.files.length > 0) this.file = elem.files[0];
    },

    submitFile() {
      let formData = new FormData();
      formData.append("file", this.file);
      this.fileUploading = true;
      axios
        .post("/api/backend/v1/configuration/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.fileUploading = false;
          if (!!response && !!response.data) {
            this.uploadresult = response.data;
            if (this.uploadresult.Success) {
              EventBus.$emit("add-toastr", {
                text: "Regio's worden opnieuw ingedeeld",
                type: "success"
              });
            }
          }
        })
        .catch(error => {
          this.fileUploading = false;
          if (
            !!error.response &&
            !!error.response.data &&
            !!error.response.data.Message
          ) {
            this.uploadresult.Success = false;
            this.uploadresult.Message = error.response.data.Message;
          }
        });
    },

    getStatus() {
      axios
        .get("/api/backend/v1/configuration/status")
        .then(response => {
          if (!!response && !!response.data) {
            this.configuration = response.data;

            this.pageLoaded = true;
          }
        })
        .catch(error => {});
    },


    addDealerNummer() {
        this.dealer.Dealernummer = this.dealerNummerValue

        var selectedAutobedrijf = get(this.selectedOptions, "autobedrijfValue", []);
        this.dealer.AutobedrijfID = get (selectedAutobedrijf, "Id", []);

        var selectedVestiging = get(this.selectedOptions, "vestigingValue", []);
        this.dealer.VestigingID = get (selectedVestiging, "Id", []);

        axios.post("/api/backend/v1/configuration/adddealernummer", this.dealer, {
          headers: { "Content-Type": "application/json" }
        })
        .then(response => {
          if(!!response && !!response.data && response.data.Success) {
            EventBus.$emit("add-toastr", {
              text: response.data.Message,
              type: "success"
            })
          }
        }

        );
    }
  }
});
